import {addSpanAnchors} from "./hiddenLinksHelpers";
export default function initSpanAnchors () {
    addSpanAnchors();
}
